"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconPencil', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M4.90216832,13.512 L11.0001683,7.414 L12.5861683,9 L6.48816832,15.098 L4.37416832,15.626 L4.90216832,13.512 Z M14.0001683,7.586 L12.4141683,6 L14.0001683,4.414 L15.5861683,6 L14.0001683,7.586 Z M17.7071683,5.293 L14.7071683,2.293 C14.3161683,1.903 13.6831683,1.903 13.2931683,2.293 L3.29316832,12.293 C3.27716832,12.309 3.27116832,12.33 3.25616832,12.348 C3.21216832,12.399 3.17716832,12.456 3.14416832,12.518 C3.11016832,12.576 3.07916832,12.634 3.05816832,12.698 C3.05116832,12.719 3.03616832,12.736 3.03016832,12.758 L2.03016832,16.758 C1.94416832,17.099 2.04516832,17.459 2.29316832,17.707 C2.48216832,17.897 2.73816832,18 3.00016832,18 C3.08116832,18 3.16216832,17.991 3.24216832,17.97 L7.24216832,16.97 C7.26416832,16.964 7.28016832,16.949 7.30216832,16.942 C7.36716832,16.921 7.42516832,16.889 7.48616832,16.854 C7.54416832,16.821 7.59916832,16.789 7.64916832,16.745 C7.66816832,16.73 7.69016832,16.724 7.70716832,16.707 L17.7071683,6.707 C18.0971683,6.317 18.0971683,5.684 17.7071683,5.293 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;